module.exports = __webpack_public_path__ + "static/media/save-light.d6725101.svg";